<template>
    <div :class="`as-goals-scored`">
        <div class="as-goals-scored__head">
            <IconGoalScored :fill="'#FFDD00'" />
            <span> Trên/Dưới bàn thắng  </span>
        </div>
        <div class="as-history">
            <div class="as-history-item">
                <div class="as-history-item__head">
                    <div class="as-head-tab" :class="{
                        'as-active' : activeTab === 'Over'
                    }" @click="setActiveTab('Over')">
                        Trên
                    </div>
                    <div class="as-head-tab" :class="{
                        'as-active' : activeTab === 'Under'
                    }" @click="setActiveTab('Under')">
                        Dưới
                    </div>
                </div>
                <div class="as-history-item__body">
                    <div class="as-competition">
                        <table class="as-competition__table">
                            <thead>
                                <tr>
                                    <th>Tổng số BT</th>
                                    <th class="as-center a">
                                        {{ footyStats?.home_name }}
                                    </th>
                                    <th class="as-center a">
                                        {{ footyStats?.away_name }}
                                    </th>
                                    <th class="as-center a">Trung bình</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>{{ textTab }} 0.5</td>
                                    <td :class="`as-center ${getClassForItem(getValueWithMode('home', `season${activeTab}05Percentage_overall`))}`">
                                        {{ getValueWithMode('home', `season${activeTab}05Percentage_overall`) }}%
                                    </td>

                                    <td :class="`as-center ${getClassForItem(getValueWithMode('away', `season${activeTab}05Percentage_overall`))}`">
                                        {{ getValueWithMode('away', `season${activeTab}05Percentage_overall`) }}%
                                    </td>
                                    <td :class="`as-center ${getClassForItem(getValueWithModeTB(`season${activeTab}05Percentage_overall`))}`">
                                        {{ getValueWithModeTB(`season${activeTab}05Percentage_overall`)}}%
                                    </td>
                                </tr>
                                <tr>
                                    <td>{{ textTab }} 1.5</td>
                                    <td :class="`as-center ${getClassForItem(getValueWithMode('home', `season${activeTab}15Percentage_overall`))}`">
                                        {{ getValueWithMode('home', `season${activeTab}15Percentage_overall`) }}%
                                    </td>
                                    <td :class="`as-center ${getClassForItem(getValueWithMode('away', `season${activeTab}15Percentage_overall`))}`">
                                        {{ getValueWithMode('away', `season${activeTab}15Percentage_overall`) }}%
                                    </td>
                                    <td :class="`as-center ${getClassForItem(getValueWithModeTB(`season${activeTab}15Percentage_overall`))}`">
                                        {{ getValueWithModeTB(`season${activeTab}15Percentage_overall`) }}%
                                    </td>
                                </tr>
                                <tr>
                                    <td>{{ textTab }} 2.5</td>
                                    <td :class="`as-center ${getClassForItem(getValueWithMode('home', `season${activeTab}25Percentage_overall`))}`">
                                        {{ getValueWithMode('home', `season${activeTab}25Percentage_overall`) }}%
                                    </td>
                                    <td :class="`as-center ${getClassForItem(getValueWithMode('away', `season${activeTab}25Percentage_overall`))}`">
                                        {{ getValueWithMode('away', `season${activeTab}25Percentage_overall`) }}%
                                    </td>
                                    <td :class="`as-center ${getClassForItem(getValueWithModeTB(`season${activeTab}25Percentage_overall`))}`">
                                        {{ getValueWithModeTB(`season${activeTab}25Percentage_overall`) }}%
                                    </td>
                                </tr>
                                <tr>
                                    <td>{{ textTab }} 3.5</td>
                                    <td :class="`as-center ${getClassForItem(getValueWithMode('home', `season${activeTab}35Percentage_overall`))}`">
                                        {{ getValueWithMode('home', `season${activeTab}35Percentage_overall`) }}%
                                    </td>
                                    <td :class="`as-center ${getClassForItem(getValueWithMode('away', `season${activeTab}35Percentage_overall`))}`">
                                        {{ getValueWithMode('away', `season${activeTab}35Percentage_overall`) }}%
                                    </td>
                                    <td :class="`as-center ${getClassForItem(getValueWithModeTB(`season${activeTab}35Percentage_overall`))}`">
                                        {{ getValueWithModeTB(`season${activeTab}35Percentage_overall`) }}%
                                    </td>
                                </tr>
                                <tr>
                                    <td>{{ textTab }} 4.5</td>
                                    <td :class="`as-center ${getClassForItem(getValueWithMode('home', `season${activeTab}45Percentage_overall`))}`">
                                        {{ getValueWithMode('home', `season${activeTab}45Percentage_overall`) }}%
                                    </td>
                                    <td :class="`as-center ${getClassForItem(getValueWithMode('away', `season${activeTab}45Percentage_overall`))}`">
                                        {{ getValueWithMode('away', `season${activeTab}45Percentage_overall`) }}%
                                    </td>
                                    <td :class="`as-center ${getClassForItem(getValueWithModeTB(`season${activeTab}45Percentage_overall`))}`">
                                        {{ getValueWithModeTB(`season${activeTab}45Percentage_overall`) }}%
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <!-- <div class="as-competition">
                        <table class="as-competition__table">
                            <thead>
                                <tr>
                                    <th>H1/H2</th>
                                    <th class="as-center a">{{ footyStats?.home_name }}</th>
                                    <th class="as-center a">{{ footyStats?.away_name }}</th>
                                    <th class="as-center a">Trung bình</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(item, key) in list" :key="key">
                                    <td>H1 {{ textTab }} {{ item.title }}</td>
                                    <td :class="`as-center ${getClassForItem(
                                        getValueWithMode('home', `season${activeTab}${item.value}PercentageHT_overall`)
                                    )}`">
                                        {{ getValueWithMode('home', `season${activeTab}${item.value}PercentageHT_overall`) }}%
                                    </td>
                                    <td :class="`as-center ${getClassForItem(
                                        getValueWithMode('away', `season${activeTab}${item.value}PercentageHT_overall`)
                                        )}`">
                                        {{ getValueWithMode('away', `season${activeTab}${item.value}PercentageHT_overall`) }}%
                                    </td>
                                    <td
                                        :class="`as-center ${getClassForItem(
                                            calculatorAVG(
                                                getValueWithMode('home', `season${activeTab}${item.value}PercentageHT_overall`),
                                                getValueWithMode('away', `season${activeTab}${item.value}PercentageHT_overall`)
                                            )
                                        )}`"
                                    >
                                        {{
                                            calculatorAVG(
                                                getValueWithMode('home', `season${activeTab}${item.value}PercentageHT_overall`),
                                                getValueWithMode('away', `season${activeTab}${item.value}PercentageHT_overall`)
                                            )
                                        }}%
                                    </td>
                                </tr>
                                <tr v-for="(item, key) in list" :key="key">
                                    <td>H2 {{ textTab }} {{ item.title }}</td>
                                    <td :class="`as-center ${getClassForItem(
                                        getValueWithMode('home', `season${activeTab}${item.value}PercentageHT_overall`)
                                    )}`">
                                        {{ getValueWithMode('home', `season${activeTab}${item.value}PercentageHT_overall`) }}%
                                    </td>
                                    <td :class="`as-center ${getClassForItem(
                                        getValueWithMode('away', `season${activeTab}${item.value}PercentageHT_overall`)
                                        )}`">
                                        {{ getValueWithMode('away', `season${activeTab}${item.value}PercentageHT_overall`) }}%
                                    </td>
                                    <td
                                        :class="`as-center ${getClassForItem(
                                            calculatorAVG(
                                                getValueWithMode('home', `season${activeTab}${item.value}PercentageHT_overall`),
                                                getValueWithMode('away', `season${activeTab}${item.value}PercentageHT_overall`)
                                            )
                                        )}`"
                                    >
                                        {{
                                            calculatorAVG(
                                                getValueWithMode('home', `season${activeTab}${item.value}PercentageHT_overall`),
                                                getValueWithMode('away', `season${activeTab}${item.value}PercentageHT_overall`)
                                            )
                                        }}%
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div> -->
                </div>
            </div>
        </div>
    </div>
</template>
<script setup lang="ts">
    import IconGoalScored from '~src/components/icons/foot_stats/IconGoalScored.vue';
    import type { IMatch } from '~src/interfaces';
    import type { IFootyStats, ITeam, IStatsParent } from '~src/interfaces/footystats';
    import { ref, computed } from 'vue';
    import { getClassForItem } from '~src/helpers/footystats';

    interface Props{
        match: IMatch;
        mode?: string;
        footyStats: IFootyStats | null;
        homeTeamInfo: ITeam | null;
        awayTeamInfo: ITeam | null;
    }

    const props = withDefaults(defineProps<Props>(),{
        mode: 'as-win'
    })

    const list = [
        {
            value: '05',
            title: '0.5',
        },
        {
            value: '15',
            title: '1.5',
        },
        {
            value: '25',
            title: '2.5',
        }
    ];

    const activeTab = ref('Over')
    const setActiveTab = (tab: string) => {
        activeTab.value = tab;
    };

    const textTab = computed<string>(() => {
        return activeTab.value === 'Over' ? 'Trên' : 'Dưới';
    });

    const homeTeamLastX = computed<IStatsParent>(() => {
        return props.footyStats?.home_team_last_x ?? {} as IStatsParent;
    });

    const awayTeamLastX = computed<IStatsParent>(() => {
        return props.footyStats?.away_team_last_x ?? {} as IStatsParent;
    });

    const getValueWithModeTB = (mode = 'btts', mode_half = '') => {
        const home = getValueWithMode('home', mode, mode_half);
        const away = getValueWithMode('away', mode, mode_half);

        return (home + away) / 2;
    }

    const getValueWithMode = (team = 'home', mode = 'btts', mode_half = '') => {
        const __data: IStatsParent = team === 'home' ? homeTeamLastX.value : awayTeamLastX.value;
        let __mode = mode
        if(mode_half){
            __mode = mode_half
        }
        if (!__data || !__data.stats || !__data.stats.hasOwnProperty(__mode)) {
            return 0;
        }

        return __data.stats[__mode] as number;
    }

    const calculatorAVG = (home: number, away: number) => {
        const _avg = (home + away) / 2;

        return Math.round(_avg);
    };
</script>

<script lang="ts">
export default {};
</script>
